/**
 * "Shape at a glance" — figure S4's six mini tiles in the left panel:
 * Inventions · Holes · Bridges · Frontier directions · Synergy cells ·
 * 2-D artifacts discarded (the last spanning both columns).
 *
 * A tile prints a NUMBER only when something actually computed it. A measured
 * zero is the digit 0; a value nobody has computed prints the reason instead.
 * "--" is never shown, and a 0 never stands in for "not computed" — that is the
 * exact dishonesty the dashboard rules ban.
 */
import type { OwnScopeShapeTile } from '../../lib/whitespace'

export interface OwnShapeGlanceProps {
  tiles: OwnScopeShapeTile[]
}

export default function OwnShapeGlance({ tiles }: OwnShapeGlanceProps) {
  return (
    <section data-part="OwnShapeGlance" aria-label="Shape at a glance" className="mt-4">
      <h3 className="mb-1.5 text-[12.5px] font-bold text-gray-900">Shape at a glance</h3>
      <dl className="grid grid-cols-2 gap-2">
        {tiles.map((tile, i) => (
          <div
            key={tile.label}
            className={`rounded-lg border border-gray-200 bg-white px-2.5 py-2 ${i === tiles.length - 1 ? 'col-span-2' : ''}`}
          >
            <dt className="text-[10px] font-bold uppercase leading-tight tracking-wide text-gray-500">
              {tile.label}
            </dt>
            <dd className="mt-0.5 text-[19px] font-extrabold leading-none text-gray-900">
              {tile.value === null ? (
                <span className="text-[11px] font-normal text-gray-500">{tile.note}</span>
              ) : (
                tile.value
              )}
            </dd>
            {tile.value !== null && tile.note && (
              <p className="mt-0.5 text-[10.5px] text-gray-500">{tile.note}</p>
            )}
          </div>
        ))}
      </dl>
    </section>
  )
}
